import Footer from "../footer/Footer";
import { Outlet } from "react-router-dom";
import LoadingSpinner from "../../loading/Loading";
import ProfileFunction from "../../functions/profileFunction/ProfileFunction";



export default function MainLayout({ children }) {
  ProfileFunction();
  

  return (
    <>
      <LoadingSpinner></LoadingSpinner>
      <Outlet />
      <Footer />
    </>
  );
}
